export const stripHtml = (html) => String(html || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();

export const wordCount = (html) => {
  const text = stripHtml(html);
  return text ? text.split(" ").length : 0;
};

export const readTimeMinutes = (html, wpm = 220) => Math.max(1, Math.round(wordCount(html) / wpm));
